import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'utils/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from 'store/configureStore';
import LocalizeProvider from 'pages/LocalizeProvider';
import { BrowserRouter } from 'react-router-dom';
import { init as sentryErrorTracking } from 'shared/lib/lib/sentryErrorTracking';
import App from './pages/App';
import * as serviceWorker from './serviceWorker';
import 'video.js/dist/video-js.css';

const store = configureStore();

if (process.env.NODE_ENV === 'production') {
  sentryErrorTracking();
}

/* eslint-disable */
ReactDOM.render(
  <Provider store={store}>
    <LocalizeProvider>
      <BrowserRouter basename={process.env.REACT_APP_ROUTE_BASENAME}>
        <App />
      </BrowserRouter>
    </LocalizeProvider>
  </Provider>,
  document.getElementById('root')
);
/* eslint-enable */

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
